module.exports = __webpack_public_path__ + "img/garlic-bread.23da6368.jpg";